import React, { useEffect, useState } from "react";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Button/CustomButton";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import PublishShiftItem from "./PublishShiftItem";
import CheckBox from "components/common/checkBox/checkbox";
import { getAllPendingShifts } from "store/selector/rostering.selector";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SHIFT_STATUS, TOAST_TYPE } from "Constants/constant";
import RosteringAPI from "store/services/rostering.services";
import { workerAndParticipantShiftStatusChangedLocally } from "store/actions/rostering.actions";
import {
  capitalizeFirstLetter,
  formatDateIntoDMY,
  formatDateIntoDMMMY,
  formatDateIntoDMYToDisplay,
} from "Utils/utils";
import { showToast } from "store/actions/general.actions";
import { TOAST_IDS } from "store/constants";
import moment from "moment";
import { apiPostRequest } from "helpers/Requests";
import { URL_ROSTERING_WORKER_AND_PARTICIPANT_LIST } from "store/services/URL";
import PublishShiftPersonCell from "./PublishShiftPersonCell";
import {
  dedupePublishModalShifts,
  getLocalAdvancePublishStatusPatch,
  getPublishShiftDisplayMeta,
  getPublishShiftLengthLabel,
} from "./publishShiftModalDisplay";
import useCareLabels from "hooks/useCareLabels";
// import { getWorkerAndPartsListLoader } from "store/selector/rostering.selector";

const PubishShiftModal = (props) => {
  const {
    isShow,
    handleClose,
    calendarView,
    isUserGracePeriodOver,
    selectedDateTypes,
    handleGetShiftStats,
    startDate,
    endDate,
    selectedOps,
    participantNameLabel: participantNameLabelProp,
  } = props;
  const { participantNameLabel: participantNameLabelHook } = useCareLabels();
  const participantNameLabel = participantNameLabelProp ?? participantNameLabelHook;

  const dispatch = useDispatch();

  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [shifts, setModalShifts] = useState([]);

  //   const shifts = useSelector((state) => getAllPendingShifts(state));
  //   const isDataLoading = useSelector(getWorkerAndPartsListLoader);

  const fetchModalShifts = async () => {
    if (!calendarView || !startDate || !endDate) return;

    setIsLoading(true);

    const params = {
      page: 1,
      per_page: 500,
      type: calendarView === "worker-view" ? "worker" : "participant",
      from_date: formatDateIntoDMY(startDate),
      to_date: formatDateIntoDMY(endDate),
      sort: "asc",
      status: "pending",
    };

    if (
      calendarView === "worker-view" &&
      selectedOps !== null &&
      selectedOps?.length > 0
    ) {
      params.workers = selectedOps.map((x) => x.value);
      params.per_page = 100;
    } else if (
      calendarView === "participant-view" &&
      selectedOps?.length > 0 &&
      selectedOps !== null
    ) {
      params.participants = selectedOps.map((x) => x.value);
      params.per_page = 100;
    }

    try {
      const response = await apiPostRequest(
        URL_ROSTERING_WORKER_AND_PARTICIPANT_LIST,
        params
      );

      if (response?.data) {
        const calendarView =
          response?.data?.worker_participant_listing?.hasOwnProperty("worker")
            ? "worker"
            : "participant";
        const allWorkers =
          response?.data?.worker_participant_listing?.[`${calendarView}`]
            ?.data || [];

        if (allWorkers) {
          const reduceData = allWorkers.reduce((obj, data) => {
            const name = `${data?.first_name} ${data?.last_name}`;
            const alterData = data?.shifts?.map((x) => {
              let modifiedShift = { ...x };

              if (calendarView === "worker") {
                modifiedShift.worker = { name: name };
                modifiedShift.participant = {
                  ...modifiedShift.participant,
                  name: `${modifiedShift.participant?.first_name} ${modifiedShift.participant?.last_name}`,
                };
              } else {
                modifiedShift.participant = {
                  id: data?.id,
                  uuid: data?.uuid,
                  first_name: data?.first_name,
                  last_name: data?.last_name,
                  profile_picture: data?.profile_picture,
                  name: name,
                };
                modifiedShift.worker = {
                  ...modifiedShift.worker,
                  name: `${modifiedShift.worker?.first_name} ${modifiedShift.worker?.last_name}`,
                };
              }

              return modifiedShift;
            });

            Object.assign(obj, {
              allShifts: obj["allShifts"]
                ? [...obj.allShifts, ...alterData]
                : [...alterData],
            });
            return obj;
          }, {});
          const shifts =
            reduceData?.allShifts
              ?.filter((x) => x.status === SHIFT_STATUS.PENDING)
              ?.sort((a, b) => a.worker_id < b.worker_id) || [];
          if (!shifts || !Array.isArray(shifts)) return [];
          const filterShifts = shifts?.filter((shift) => {
            const shiftDate = moment(shift?.shift_date, "YYYY-MM-DD");
            return shiftDate.isSameOrAfter(moment(), "day");
          });

          setModalShifts(dedupePublishModalShifts(filterShifts));
        }
      }
    } catch (error) {
      toast.error("Error fetching modal shifts:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isShow) {
      fetchModalShifts();
    }
    //   refreshCalendar({ isRefreshCall: true ,page:1,per_page:500,status:"pending"});
  }, [startDate, endDate, calendarView]);

  // Function to filter shifts based on the start_time
  //   const filterUpcomingShifts = (shifts = []) => {
  //      if (!shifts || !Array.isArray(shifts)) return [];
  //     return data?.filter((shift) => {
  //       const shiftDate = moment(shift?.shift_date, "YYYY-MM-DD");
  //       return shiftDate.isSameOrAfter(moment(), "day");
  //     });
  //   };


  const data = shifts;

    const handlePublishShift = async () => {
    if (isUserGracePeriodOver) {
      return;
    }
    if (checkboxes.length === 0) {
      dispatch(
        showToast({
          id: TOAST_IDS.PUBLISH_SHIFT_MODAL_BUTTON_ID,
          type: TOAST_TYPE.DEFAULT,
          title: "No Any Shift Selected!",
        })
      );
      return;
    }
    const data = {
      uuid: checkboxes.map((x) => x.uuid),
      status: SHIFT_STATUS.PUBLISHED,
    };
    try {
      setIsLoading(true);
      const response = await RosteringAPI.changeStatusWorkerAndParticipantShift(
        data
      );
      if (response) {
        // Advance: patch local status to match V5 publish (Accepted/Published).
        // Basic/legacy rows stay unchanged (status PUBLISHED only).
        const shiftsForLocalUpdate = checkboxes.map((shift) => {
          const advancePatch = getLocalAdvancePublishStatusPatch(shift);
          return advancePatch ? { ...shift, ...advancePatch } : shift;
        });

        dispatch(
          workerAndParticipantShiftStatusChangedLocally({
            shifts: shiftsForLocalUpdate,
            status: SHIFT_STATUS.PUBLISHED,
            calendarView:
              calendarView === "worker-view" ? "worker" : "participant",
          })
        );
        toast.success(
          `Shift ${capitalizeFirstLetter(
            SHIFT_STATUS.PUBLISHED
          )}  Successfully!`
        );
      }
      if (selectedOps?.length > 0) {
        handleGetShiftStats(startDate, endDate, selectedOps);
      } else {
        handleGetShiftStats(startDate, endDate);
      }

      setIsLoading(false);
      handleClose();
    } catch (err) {
      setIsLoading(false);
      console.log("err", err);
      toast.error(err?.message ?? "Something went wrong!");
    }
  };

  const toggleCheckboxes = (val) => {
    setCheckboxes(val ? data : []);
  };

  useEffect(() => {
    if (
      data &&
      checkboxes &&
      //   checkboxes?.length === data?.filter((s) => s?.worker_id ).length &&
      checkboxes?.length === data?.length &&
      data.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);

  const handleCheckboxChange = (e, uuid, item) => {
    const filteredList = checkboxes.filter((c) => c.uuid !== uuid);
    if (e) {
      filteredList.push({ ...item });
    }
    setCheckboxes([...filteredList]);
  };

  const modalFooter = () => (
    <>
      <CustomButton
        variant="danger"
        clickHandler={() => {
          handleClose();
        }}
        label="Cancel"
      />
      <CustomButton
        clickHandler={handlePublishShift}
        showLoading={isLoading}
        isDisabled={
          isLoading || isUserGracePeriodOver || checkboxes.length === 0
        }
        label="Publish"
      />
    </>
  );

  const publishShiftContent = () => {
    return (
      <div className="p-4">
        {data && data?.length > 0 && (
          <div className="py-2">
            <h4>
              <b>Total Shifts:</b> {data?.length}
            </h4>
          </div>
        )}
        <div className="border rounded-lg overflow-hidden">
          <div className="max-h-[350px] overflow-y-auto">
            <table className="w-full border-collapse">
              <thead className="bg-blue-50 text-left sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-4 w-10 text-center">
                    <CheckBox
                      checked={allSelected}
                      handleChange={(e) => toggleCheckboxes(e)}
                    />
                  </th>
                  <th className="px-4 py-3 text-sm">Worker Name</th>
                  <th className="px-4 py-3 text-sm">{participantNameLabel}</th>
                  <th className="px-4 py-3 text-center text-sm">Shift Date</th>
                  <th className="px-4 py-3 text-center text-sm">
                    Shift Length
                  </th>
                  <th className="px-4 py-3 text-center text-sm">Start Time</th>
                  <th className="px-4 py-3 text-center text-sm">End Time</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((shift, index) => {
                    const displayMeta = getPublishShiftDisplayMeta(shift);

                    return (
                      <tr
                        key={shift.uuid || index}
                        title={displayMeta.summary || undefined}
                        className={`border-t ${displayMeta.rowAccentClass}`}
                      >
                        <td className="px-4 py-3 text-center">
                          <CheckBox
                            checked={checkboxes.some(
                              (c) => c.uuid === shift.uuid
                            )}
                            handleChange={(e) =>
                              handleCheckboxChange(e, shift.uuid, shift)
                            }
                          />
                        </td>
                        <td className="px-4 text-sm py-3 align-top">
                          <PublishShiftPersonCell
                            people={displayMeta.workers}
                            showAvatars={displayMeta.showWorkerAvatars}
                            emptyLabel={
                              displayMeta.workers.length === 0 &&
                              displayMeta.openSlotCount === 0
                                ? displayMeta.workerEmptyLabel
                                : null
                            }
                            openSlotCount={displayMeta.openSlotCount}
                            type="worker"
                          />
                        </td>
                        <td className="px-4 text-sm py-3 align-top">
                          <PublishShiftPersonCell
                            people={displayMeta.participants}
                            showAvatars={displayMeta.showParticipantAvatars}
                            type="participant"
                          />
                        </td>
                        <td className="px-4 py-3 text-sm text-center">
                          <div className="text-gray-500">
                            {formatDateIntoDMYToDisplay(shift.shift_date)}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-center">
                          <div className="text-gray-500">
                            {getPublishShiftLengthLabel(shift)}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-center">
                          <div className="text-gray-500">
                            {moment(
                              shift.start_time,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("hh:mm a")}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-center">
                          <div className="text-gray-500">
                            {moment(shift.end_time, "YYYY-MM-DD HH:mm:ss").format(
                              "hh:mm a"
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="py-6 text-center text-red-600">
                      No Shift to be Published!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isShow && (
        <ModalSkeleton
          title={`Publish Shifts From ${formatDateIntoDMMMY(
            selectedDateTypes?.startDate
          )} To ${formatDateIntoDMMMY(selectedDateTypes?.endDate)}`}
          isOpen={isShow}
          cssClass="w-[70%]"
          bodyPadding="px-0"
          closeModal={() => {
            handleClose();
          }}
          modalFooter={modalFooter()}
        >
          {isLoading ? (
            <div
              className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
            >
              <CircularLoader
                classes="flex justify-center items-center"
                classloader="loader-l"
              />
            </div>
          ) : (
            publishShiftContent()
          )}
        </ModalSkeleton>
      )}
    </div>
  );
};

export default PubishShiftModal;
